import React from "react";
import { Grid, Typography, CircularProgress , Popover} from "@mui/material";
import CustomStepper from "../stepper";
import ModalForm from "../../utilities/modal";
import Button from "../../utilities/button";
import FAQPage from "../../FAQPage";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MagnifyingGlassPopUp from "./magnifyingGlassPopUp";
import FAQ from "../../assets/FAQ.png";
import "./mainTemplate.css";
import "./FAQButton.css";
import { useNavigate } from "react-router-dom";
import { awsDetailsContext, genesysDetailsContext, loginPageContext } from "../../context";
// import Login from "../login/login";
import {validateRoleArn} from "../../preDefinedFunctions/inputFieldValidations.js"
 
export default function MainTemplate({ children }) {
  const navigate = useNavigate();
  const pathName = window.location.pathname;
  const genesysDetails = React.useContext(genesysDetailsContext);
  const AwsDetails = React.useContext(awsDetailsContext);
  const [nextButtonDisabled, setNextButtonDisabled] = React.useState(true);
 const userLoginDetailsContext= React.useContext(loginPageContext)
  const [openMagnifyingGlassPopUp, setOpenMagnifyingGlassPopUp] = React.useState(false);
  const [faqVisible, setFaqVisible] = React.useState(false);
  // const [profileVisible, setProfileVisible] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState("");
  
  const [pageErrorMessage, setPageErrorMessage] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [notFound, setNotFound] = React.useState(false);
  const [refresh, setRefresh] = React.useState(0); // To re-render on orgName change
 const [anchorEl, setAnchorEl] = React.useState(null);
const handleProfileClick = (event) => setAnchorEl(event.currentTarget);
const handleProfileClose = () => setAnchorEl(null);
const [showLogoutConfirm, setShowLogoutConfirm] = React.useState(false);
const openProfile = Boolean(anchorEl);


React.useEffect(() => {
  const interval = setInterval(() => {
    const orgName = genesysDetails?.organizationName?.trim();
    const genRegion = genesysDetails?.genesysRegion?.trim();
    const clientId = genesysDetails?.clientId?.trim();
    const clientSecret = genesysDetails?.clientSecret?.trim();
 
    const awsAccountNumber = AwsDetails?.awsAccountNumber?.trim();
    const awsRegion = AwsDetails?.awsRegion?.trim();
    const instanceId = AwsDetails?.instanceId?.trim();
    const roleArn = AwsDetails?.roleArn?.trim();
    const domainName = AwsDetails?.domainName?.trim();
 
    if (
      pathName === "/Genesys-Cloud-Credentials" &&
      orgName &&
      genRegion &&
      clientId &&
      clientSecret
    ) {
      setNextButtonDisabled(false);
    } 
    else if (
  pathName === "/Aws-Account-Details" &&
  awsAccountNumber &&
  awsRegion &&
  instanceId &&
  roleArn &&
  domainName
) {
  setNextButtonDisabled(false);
}
    // else if (pathName === "/Migration") {
    //   if (genesysDetails.UiCallRecordingsMetrics !== undefined) {
    //     setNextButtonDisabled(false);
    //   } else {
    //     setNextButtonDisabled(true);
    //   }
    // }
     else {
      setNextButtonDisabled(true);
    }
    setRefresh((prev) => prev + 1); // optional force rerender
  }, 500);
 
  return () => clearInterval(interval);
}, [genesysDetails, AwsDetails, pathName]);
 
 const handleLogoutClick = () => {
  // show confirmation modal
  setShowLogoutConfirm(false);
};
const confirmLogout = () => {
  navigate("/"); // go back to login
};

const cancelLogout = () => {
  setShowLogoutConfirm(false);
  
  // const navigate = useNavigate();
};
  const handleNext = () => {
    const orgName = genesysDetails?.organizationName || "";
    const genRegion = genesysDetails?.genesysRegion || "";
    const clientId = genesysDetails?.clientId || "";
    const clientSecret = genesysDetails?.clientSecret || "";
   
 
    if (orgName.trim() === "") {
      setErrorMessage("Please enter your Organization Name before proceeding.");
      return;
    }
     if (genRegion.trim() === "") {
      setErrorMessage("Please enter your Genesys Region before proceeding.");
      return;
    }
     if (clientId.trim() === "") {
      setErrorMessage("Please enter your Client Id before proceeding.");
      return;
    }
     if (clientSecret.trim() === "") {
      setErrorMessage("Please enter your Client Secret before proceeding.");
      return;
    }
 
 
    setErrorMessage("");
    navigate("/Aws-Account-Details");
    console.log("Handle Save Company Details Form");
  };

  const handleBackClick = () => {
  navigate("/Select-Metrics");
};
const LoginPageNavigation=()=>{
  setShowLogoutConfirm(true);
  // navigate("/")
}
 
  const handleAwsDetailsNext=()=>{
const awsAccountNumber = AwsDetails?.awsAccountNumber || "";
const awsRegion = AwsDetails?.awsRegion || "";
const InstanceId = AwsDetails?.instanceId || "";
const RoleArn = AwsDetails?.roleArn || "";
const DomainName = AwsDetails?.domainName || "";
 
        if (awsAccountNumber.trim() === "") {
      setErrorMessage("Please enter your Aws Account Number before proceeding.");
      return;
    }
     if (awsRegion.trim() === "") {
      setErrorMessage("Please enter your Aws Region before proceeding.");
      return;
    }
         if (InstanceId.trim() === "") {
      setErrorMessage("Please enter your Instance Id before proceeding.");
      return;
    }
    if (RoleArn.trim() === "") {
      setErrorMessage("Please enter your Role Arn before proceeding.");
      return;
    }
    if (DomainName.trim() === "") {
      setErrorMessage("Please enter your Domain Name before proceeding.");
      return;
    }
    const result = validateRoleArn(RoleArn);
    if (!result.isValid) {
    setErrorMessage("Please enter a valid Role Arn.");
    return;
  }else{
    setErrorMessage("");
    navigate("/Migration");
  }

    
   
  }

  const handleMigrationNext = () => {
  console.log("Migration next clicked");
  // Add actual navigation or action here
};
// const excludedPaths = [
//   "/Queue-Metrics",
//   "/Agent-Metrics",
//   "/Sentiment-Analysis-Metrics",
//   "/CallRecording-Metrics"
// ];


  const steps = ["Genesys Credentials", "AWS Account Details", "Migration"];
  const getActiveStep = (path) => {
    // if (excludedPaths.includes(path)) return null;
  switch (path) {
    case "/Aws-Account-Details":
      return 1;
    case "/Migration":
      
      return 2;
    case "/Select-Metrics":
    case "/Sentiment-Analysis-Metrics":
      case "/CallRecording-Metrics":
      case "/Queue-Metrics":
      case "/Agent-Metrics":
       return 3;
    default:
      return 0;
  }
};
//  console.log("userLoginDetailsContext",userLoginDetailsContext.username)
  return (
    <Grid container className="main-card">
      <Grid item md={2} xs={0} />
      <Grid item md={8} xs={12} container spacing={1} className="connect-container">
        <Grid item md={3} xs={12} className="stepper-container">
          <CustomStepper steps={steps} activeStep={getActiveStep(pathName)} />
        </Grid>
 
        <Grid item md={9} xs={12} className="main-container">
          <Grid item xs={12} className="children-container">
            <div className="children-mob-container">
              {children}
              {errorMessage && (
                <Typography className="error-text">{errorMessage}</Typography>
              )}
              {pageErrorMessage && (
                <Typography className="error-text">{pageErrorMessage}</Typography>
              )}
            </div>
          </Grid>
 
{!notFound && (
  <Grid item xs={12} className="action-buttons">
    {loading ? (
      <CircularProgress sx={{ color: "#1a567a" }} />
    ) : (
      <>
        {pathName === "/Genesys-Cloud-Credentials" && (
          <Button
            label="Next"
            disabled={nextButtonDisabled}
            className={nextButtonDisabled ? "disabled-next-button" : ""}
            handleClick={handleNext}
          />
        )}
 
        {pathName === "/Aws-Account-Details" && (
          <Button
            label="Next"
            disabled={nextButtonDisabled}
            className={nextButtonDisabled ? "disabled-next-button" : ""}
            handleClick={handleAwsDetailsNext}
          />
        )}


{(
  pathName === "/Queue-Metrics" ||
  pathName === "/Agent-Metrics" ||
  pathName === "/Sentiment-Analysis-Metrics" ||
  pathName === "/CallRecording-Metrics"
) && (
  <Button
    label="Back"
    className="back-button"
    handleClick={handleBackClick}
  />
)}


         {/* {pathName === "/Migration" && (
          <Button
            label="Next"
            disabled={nextButtonDisabled}
            className={nextButtonDisabled ? "disabled-next-button" : ""}
            handleClick={handleMigrationNext} // Define this function if not present
          />
        )} */}
        
      </>
    )}
  </Grid>
)}
 
        </Grid>
      </Grid>
      <Grid item md={2} xs={0} />
 
      {openMagnifyingGlassPopUp && (
        <ModalForm
          className="short-modal"
          open={openMagnifyingGlassPopUp}
          handleClose={() => setOpenMagnifyingGlassPopUp(false)}
          component={<MagnifyingGlassPopUp />}
        />
      )}
 
      <div className="faq-bar">
        <button className="faq-button" onClick={() => setFaqVisible(true)}>
          <img src={FAQ} alt="FAQ" className="faq-logo" loading="lazy" />
        </button>
        <button className="profile-button" onClick={handleProfileClick}>
  <AccountCircleIcon className="profile-icon" />
</button>

        {faqVisible && (
          <ModalForm
            title="FAQ'S"
            open={faqVisible}
            handleClose={() => setFaqVisible(false)}
            showCloseIcon={true}
            component={<FAQPage onClose={() => setFaqVisible(false)} />}
          />
        )}
      </div>

       {/* {profileVisible && (
    <ModalForm
      title="Profile"
      open={profileVisible}
      handleClose={() => setProfileVisible(false)}
      showCloseIcon={true}
      component={
        <div style={{ padding: "20px" }}>
          <Typography variant="h6">Logged in as:</Typography>
          <Typography variant="body1" sx={{ marginTop: "8px" }}>
            {genesysDetails?.userName || genesysDetails?.organizationName || "Unknown User"}
          </Typography>
        </div>
      }
    />
  )} */}

  {showLogoutConfirm && (
  <div className="modal-backdrop">
  // <div className="modal">
        <div className="modal-content">
          <p className="warning-message">
             Are you sure you want to log out?
          </p>
          <div className="cancel-ok-button">
          <Button label="Cancel" handleClick={cancelLogout} />
          <Button label="OK" handleClick={confirmLogout} />
          </div>
        </div>
      // </div>  
      </div>
       )}
  
  <Popover
  open={openProfile}
  anchorEl={anchorEl}
  onClose={handleProfileClose}
  anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'right',
  }}
  transformOrigin={{
    vertical: 'top',
    horizontal: 'right',
  }}
  PaperProps={{
    sx: {
      padding: '12px 20px',
      borderRadius: '12px',
      boxShadow: 3,
      minWidth: '180px',
      marginTop: '-32px',
      marginLeft: '-30px',
    },
  }}
>
  <Typography variant="subtitle1" className="login-in-as">Logged in as: {""}
  <Typography component="span" variant="body2" sx={{ marginTop: '4px',color:"#1976d2" }}>
{localStorage.getItem("username") || "Unknown User"}  </Typography>
</Typography>
{/* <Typography variant="subtitle1">
  Logged in as:{" "}
  <Typography component="span" variant="body2">
    {localStorage.getItem("username") || "Unknown User"}
  </Typography>
</Typography> */}

<button className="logout" onClick={LoginPageNavigation}>Log Out</button>

</Popover>


    </Grid>
  );
}
 